<template>
  <div id="distribution_pop_one">
    <div class="pop_warp pop_flex">
      <div class="pop_box">
        <div class="pop_top">{{distributeItem.type ? '添加游戏' : '添加量表'}}</div>
        <div class="pop_middle">
          <div class="mid_box" v-for="(item, index) in finishData" :key="index">
            <p v-if="item.tag">{{item.tag}}</p>
            <span style="display:inline-block;padding-bottom: 12px;margin-right: 15px" v-for="(value, count) in item.value" :key="count">
              <a-checkbox :checked="value.flag" @change="changHandle(value)">{{value.value}}</a-checkbox>
            </span>
          </div>
        </div>
        <div class="pop_foot pop_flex">
          <a-button @click="updateRemoveHandle" style="margin-right: 8px;">取消</a-button>
          <a-button type="primary" @click="addHandle" :disabled="addShowHandle">添加</a-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'

export default {
  name: 'DistributionPopOne',
  props: [
    'tags'
  ],
  data (){
    return {
      finishData: []
    }
  },
  computed: {
    ...mapState([
      'distributeItem',
      'allSurveys',
      'gameGroups'
    ]),
    addShowHandle () {
      let count = 0
      this.finishData.map(item => {
        item.value.map(data => {
          if (data.flag) {
            count++
          }
        })
      })
      return count ? false : true
    }
  },
  methods: {
    ...mapMutations([
      'setPopOneShow'
    ]),
    changHandle (tag) { // 选中和取消选中
      this.finishData.map(item => {
        item.value.map(data => {
          if (tag.value === data.value) {
            data.flag = !data.flag
          }
        })
      })
    },
    updateRemoveHandle () { // 取消按钮   取消选中的样式
      this.setPopOneShow(false)
      this.finishData.map((item) => {
        item.value.map(data => {
          this.tags.includes(data.value) ? (data.flag = true) : (data.flag = false)
        })
      })
    },
    addHandle () { // 添加按钮
      let checkedScale = []
      this.finishData.map(item => { // 集合所有选中的
        item.value.map(data => {
          if (data.flag) {
            checkedScale.push(data.value)
          }
        })
      })
      this.$emit('addHandle', checkedScale)
      this.setPopOneShow(false)
      this.$message.success('操作成功')
    }
  },
  watch: {
    tags () { // 监听主页面的选中和删除  同步弹框选中样式
      this.finishData.map((item) => {
        item.value.map(data => {
          this.tags.includes(data.value) ? (data.flag = true) : (data.flag = false)
        })
      })
    }
  },
  mounted () {
    this.finishData = []
    if (this.distributeItem.type) {
      let gameMap = new Map()
      let gameType = []
      this.gameGroups.map(item => {
        if (!gameType.includes(item.GAME_SUMMARY)) {
          gameType.push(item.GAME_SUMMARY)
        }
      })
      gameType.map(item => {
        let one = []
        this.gameGroups.map(value => {
          if (item === value.GAME_SUMMARY) {
            one.push({
              lable: value.GAME_ID,
              value: value.GAME_SUMMARY,
              flag: false
            })
          }
        })
        gameMap.set(item, one)
      })
      gameMap.forEach((item, key) => {
        this.finishData.push({
          tag: key,
          value: item
        })
      })
    } else {
      let surveysMap = new Map()
      let surveysType = []
      console.log(this.allSurveys)
      this.allSurveys.map(item => {
        if (item.RIGHT) {
          if (!surveysType.includes(item.CATEGORY_TITLE)) {
            surveysType.push(item.CATEGORY_TITLE)
          }
        }
      })
      surveysType.map(item => {
        let one = []
        this.allSurveys.map(value => { // 同一类别的类别名称只显示一次（为了把checkbox放在一个循环里）
          if (item === value.CATEGORY_TITLE) {
            if (value.RIGHT) {
              one.push({
                lable: value.ID,
                value: value.SURVEY_TITLE,
                flag: false
              })
            }
          }
        })
        surveysMap.set(item, one)
      })
      surveysMap.forEach((item, key) => {
        this.finishData.push({
          tag: key,
          value: item
        })
      })
    }
  }
}
</script>

<style>
#distribution_pop_one {
  position: fixed;
  z-index: 10000;
  left: 0px;
  right: 0px;
  bottom: 0px;
  top: 0px;
  background-color: rgba(0, 0, 0, .4);
  color: #262626;
  overflow-y: auto;
}
#distribution_pop_one .pop_flex {
  display: flex;
}
#distribution_pop_one .pop_warp {
  width: 100%;
  padding: 140px 0px;
  box-sizing: border-box;
  height: auto;
  justify-content: center;
}
#distribution_pop_one .pop_box {
  width: 640px;
  background-color: #FFFFFF;
  border-radius: 4px;
}
#distribution_pop_one .pop_box .pop_top {
  padding: 16px 24px;
  border-bottom: 1px solid #EBEBEB;
  box-sizing: border-box;
  font-size: 16px;
}
#distribution_pop_one .pop_box .pop_middle {
  padding: 12px 24px 32px;
  box-sizing: border-box;
}
#distribution_pop_one .pop_box .pop_middle .mid_box {
  margin-top: 20px;
}
#distribution_pop_one .pop_box .pop_foot {
  padding: 16px;
  border-top: 1px solid #EBEBEB;
  box-sizing: border-box;
  justify-content: flex-end;
}
#distribution_pop_one .ant-checkbox-group {
  display: flex;
  flex-wrap: wrap;
}
#distribution_pop_one .ant-checkbox-group-item {
  margin-right: 5px;
  margin-top: 16px;
}
</style>
